import { Btn } from "../../utils/ui.jsx";

// Confirm dialog for deactivating / reactivating a SHELTER (Phase 4,
// docs/account-shelter-lifecycle-plan.md). `action` is null (closed) or
// { shelter, mode: "deactivate"|"reactivate", workers, inflightCount }.
// Deactivation is a CASCADE (decision 2): the shelter's active workers are
// deactivated with it, so the modal lists them. In-flight requests are NOT
// cancelled — office staff can still process them (decision 4) — so the count is
// shown for information only.
export function ShelterDeactivateConfirmModal({ action, onClose, onConfirm }) {
  if (!action) return null;
  const { shelter, mode, workers = [], sharedWorkers = [], inflightCount = 0 } = action;
  const isDeactivating = mode === "deactivate";
  const name = shelter.shelter_name || shelter.shelter_code;

  return (
    <div className="fixed inset-0 bg-black/45 z-[9999] flex items-center justify-center p-5">
      <div className="bg-white rounded-[14px] max-w-[440px] w-full p-6 shadow-[0_8px_40px_rgba(0,0,0,0.2)]">
        <div className="font-bold text-base mb-[10px]">
          {isDeactivating ? "Deactivate DFV Service?" : "Reactivate DFV Service?"}
        </div>

        {isDeactivating ? (
          <div className="text-[13px] text-zephyr-muted mb-4">
            This will retire <span className="font-semibold">{name}</span> and stop new requests
            being submitted for it.
          </div>
        ) : (
          <div className="text-[13px] text-zephyr-muted mb-4">
            This will make <span className="font-semibold">{name}</span> active again. Its workers
            are <span className="font-semibold">not</span> reactivated automatically — reactivate
            them individually if needed.
          </div>
        )}

        {isDeactivating && workers.length > 0 && (
          <div className="mb-4 rounded-[8px] border border-[#E0A100] bg-[#FFF8E1] p-3">
            <div className="text-[12px] text-[#5F4A00] mb-2">
              Its {workers.length} active {workers.length > 1 ? "workers" : "worker"} will also be{" "}
              <span className="font-bold">DEACTIVATED</span>:
            </div>
            <ul className="m-0 pl-4 text-[12px] text-[#5F4A00]">
              {workers.map((w) => (
                <li key={w.id}>{w.display_name || w.user_email || w.id}</li>
              ))}
            </ul>
          </div>
        )}

        {isDeactivating && sharedWorkers.length > 0 && (
          <div className="mb-4 rounded-[8px] border border-[#90CAF9] bg-[#E3F2FD] p-3">
            <div className="text-[12px] text-[#0D47A1] mb-2">
              {sharedWorkers.length} {sharedWorkers.length > 1 ? "workers" : "worker"} also belong
              {sharedWorkers.length > 1 ? "" : "s"} to other DFV Services, so they will only be{" "}
              <span className="font-bold">removed from this DFV Service</span> — their account stays
              active:
            </div>
            <ul className="m-0 pl-4 text-[12px] text-[#0D47A1]">
              {sharedWorkers.map((w) => (
                <li key={w.id}>{w.display_name || w.user_email || w.id}</li>
              ))}
            </ul>
          </div>
        )}

        {isDeactivating && inflightCount > 0 && (
          <div className="text-[12px] text-zephyr-muted mb-4">
            {inflightCount} in-flight {inflightCount > 1 ? "requests" : "request"} will remain and
            can still be processed by office staff.
          </div>
        )}

        <div className="flex gap-[10px] justify-end">
          <Btn variant="secondary" onClick={onClose}>
            Cancel
          </Btn>
          {/* background is mode-conditional — keep inline for that value only */}
          <Btn
            onClick={function () {
              onConfirm(action);
            }}
            style={{ background: isDeactivating ? "#C62828" : "#00897B", color: "white" }}
          >
            {isDeactivating ? "Deactivate DFV Service" : "Reactivate"}
          </Btn>
        </div>
      </div>
    </div>
  );
}
